<i
  class="material-icons help-icon"
  [placement]="placement"
  [ngbPopover]="helpText"
  container="body"
>
  info
</i>
